import { render } from "./TabooPatternModal.vue?vue&type=template&id=677194e8"
import script from "./TabooPatternModal.vue?vue&type=script&lang=js"
export * from "./TabooPatternModal.vue?vue&type=script&lang=js"

import "./TabooPatternModal.vue?vue&type=style&index=0&id=677194e8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__